<template>
  <div class="lv-page" :style="{ '--lv-bg': `url('${bgImg}')` }">
    <!-- PANEL IZQ (desktop): imagen + overlay + marca arriba + pitch abajo -->
    <div class="lv-left">
      <img class="lv-bg-img" :src="bgImg" alt="" aria-hidden="true"/>
      <div class="lv-overlay"></div>

      <header class="lv-brand">
        <div class="lv-logo"><span class="lv-logo-t">M</span></div>
        <div class="lv-brand-copy">
          <div class="lv-brand-name">MHLM</div>
          <div class="lv-brand-sub">CONSULTORA SAAS</div>
        </div>
      </header>

      <div class="lv-brand-sep"></div>
      <p class="lv-tagline">Transformamos tu administración contable</p>

      <div class="lv-spacer"></div>

      <div class="lv-pitch">
        <h2 class="lv-pitch-title">Tu administración contable,<br/>clara y en un solo lugar.</h2>
        <ul class="lv-feats">
          <li class="lv-feat">
            <span class="lv-feat-ico">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </span>
            <span><strong>Facturación</strong> y estados de cobro</span>
          </li>
          <li class="lv-feat">
            <span class="lv-feat-ico">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </span>
            <span><strong>Cuentas corrientes</strong> de clientes y proveedores</span>
          </li>
          <li class="lv-feat">
            <span class="lv-feat-ico">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
              </svg>
            </span>
            <span><strong>Informes</strong> y exportaciones a Excel</span>
          </li>
          <li class="lv-feat">
            <span class="lv-feat-ico">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </span>
            <span>Acceso con <strong>Google OAuth + 2FA</strong></span>
          </li>
        </ul>
      </div>
    </div>

    <!-- PANEL DER: form -->
    <div class="lv-right">
      <img class="lv-right-bg" :src="bgImg" alt="" aria-hidden="true"/>
      <div class="lv-right-overlay"></div>

      <div class="lv-mob-brand">
        <div class="lv-mob-logo"><span class="lv-mob-logo-t">M</span></div>
        <div>
          <div class="lv-mob-name">MHLM</div>
          <div class="lv-mob-sub">Consultora SaaS</div>
        </div>
      </div>

      <div class="lv-form-wrap">
        <!-- 2FA -->
        <template v-if="mode === '2fa'">
          <div class="lv-head-row">
            <h2 class="lv-title">Verificación en 2 pasos</h2>
            <a href="#" class="lv-link" @click.prevent="switchMode('login')">Volver</a>
          </div>
          <p class="lv-hint">Ingresá el código de 6 dígitos de tu app autenticadora, o un código de recuperación.</p>
          <form @submit.prevent="submit2fa" class="lv-form">
            <div class="lv-field">
              <svg class="lv-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><circle cx="12" cy="16" r="1"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              <input class="lv-input" v-model="otp" inputmode="numeric" maxlength="10" autocomplete="one-time-code" placeholder="123 456" autofocus />
            </div>
            <div v-if="error" class="lv-error">{{ error }}</div>
            <button class="lv-submit" type="submit" :disabled="loading">
              {{ loading ? 'Verificando...' : 'Verificar' }}
            </button>
          </form>
        </template>

        <!-- FORGOT -->
        <template v-else-if="mode === 'forgot'">
          <div class="lv-head-row">
            <h2 class="lv-title">Recuperar contraseña</h2>
            <a href="#" class="lv-link" @click.prevent="switchMode('login')">Volver</a>
          </div>
          <p class="lv-hint">Ingresá tu email. Si está registrado, te mandamos un link para restablecer la clave.</p>
          <form @submit.prevent="submitForgot" class="lv-form">
            <div class="lv-field">
              <svg class="lv-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <input class="lv-input" v-model="form.email" type="email" required placeholder="tu@empresa.com" />
            </div>
            <div v-if="forgotSent" class="lv-info">Si el email está registrado, ya te llegó (o va a llegar) el link.</div>
            <div v-else-if="error" class="lv-error">{{ error }}</div>
            <button class="lv-submit" type="submit" :disabled="loading || forgotSent">
              {{ loading ? 'Enviando...' : forgotSent ? 'Enviado ✓' : 'Enviar link' }}
            </button>
          </form>
        </template>

        <!-- LOGIN / REGISTER -->
        <template v-else>
          <div class="lv-head-row">
            <h2 class="lv-title">{{ mode === 'login' ? 'Iniciar sesión' : 'Crear cuenta' }}</h2>
            <a href="#" class="lv-link" @click.prevent="switchMode(mode === 'login' ? 'register' : 'login')">
              {{ mode === 'login' ? 'Crear una cuenta' : 'Volver' }}
            </a>
          </div>

          <form @submit.prevent="submit" class="lv-form">
            <div v-if="mode === 'register'" class="lv-field">
              <svg class="lv-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
              <input class="lv-input" v-model="form.name" type="text" required placeholder="Nombre" autocomplete="name"/>
            </div>

            <div class="lv-field">
              <svg class="lv-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <input class="lv-input" v-model="form.email" type="email" required placeholder="Dirección de correo" autocomplete="email"/>
            </div>

            <div class="lv-field">
              <svg class="lv-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input class="lv-input" v-model="form.password" :type="showPwd ? 'text' : 'password'" required
                     placeholder="Contraseña" :autocomplete="mode === 'login' ? 'current-password' : 'new-password'"/>
              <button class="lv-eye" type="button" @click="showPwd = !showPwd" tabindex="-1">
                <svg v-if="!showPwd" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>

            <div v-if="mode === 'register'" class="lv-field">
              <svg class="lv-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input class="lv-input" v-model="form.password_confirmation" type="password" required placeholder="Confirmar contraseña" autocomplete="new-password"/>
            </div>

            <div v-if="mode === 'login'" class="lv-opts">
              <label class="lv-check">
                <input type="checkbox" v-model="remember"/> Recordarme
              </label>
              <a href="#" class="lv-link" @click.prevent="switchMode('forgot')">Olvidé mi contraseña</a>
            </div>

            <div v-if="error" class="lv-error">{{ error }}</div>

            <button class="lv-submit" type="submit" :disabled="loading">
              {{ loading ? (mode === 'login' ? 'Ingresando...' : 'Creando...') : (mode === 'login' ? 'Acceder' : 'Crear cuenta') }}
            </button>
          </form>

          <div class="lv-divider"><span>o continuá con</span></div>

          <div class="lv-social">
            <button class="lv-soc" type="button" @click="loginGoogle">
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.44a5.5 5.5 0 0 1-2.39 3.61v3h3.86c2.26-2.09 3.58-5.17 3.58-8.85z"/>
                <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z"/>
                <path fill="#FBBC05" d="M5.27 14.29a7.21 7.21 0 0 1 0-4.58V6.62H1.29a12 12 0 0 0 0 10.76l3.98-3.09z"/>
                <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0A11.99 11.99 0 0 0 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"/>
              </svg>
              Google
            </button>
          </div>
        </template>
      </div>

      <div class="lv-mob-pitch">
        <h3 class="lv-mob-pitch-title">Tu administración contable,<br/>clara y en un solo lugar.</h3>
        <ul class="lv-mob-feats">
          <li><strong>Facturación</strong> y cobros</li>
          <li><strong>Cuentas corrientes</strong> de clientes</li>
          <li><strong>Informes</strong> y export a Excel</li>
        </ul>
        <div class="lv-mob-foot">© MHLM 2026 · Consultora SaaS</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';
import { login, loginTwoFactor, register, setSessionFromToken, fetchMe } from '../services/auth';

const API_BASE = process.env.VUE_APP_API_URL || 'http://localhost:8000/api';

export default {
  name: 'LoginView',
  data() {
    return {
      mode: 'login',
      form: { name: '', email: '', password: '', password_confirmation: '' },
      error: '', loading: false,
      showPwd: false, remember: true,
      bgImg: '/fondo_inicio.jpg',
      otp: '', otpTicket: '',
      forgotSent: false,
    };
  },
  async mounted() {
    const q = this.$route.query;
    if (q.error) {
      this.error = q.error === 'google_not_configured'
        ? 'Google OAuth no está configurado en el backend todavía.'
        : 'No se pudo completar el acceso con Google.';
      this.$router.replace({ query: {} });
    } else if (q.requires_2fa && q.ticket) {
      this.otpTicket = q.ticket;
      this.mode = '2fa';
      this.$router.replace({ query: {} });
    } else if (q.token) {
      setSessionFromToken(q.token);
      try { await fetchMe(); } catch { /* ignore */ }
      this.$router.replace('/dashboard');
    }
  },
  methods: {
    switchMode(m) { this.mode = m; this.error = ''; this.forgotSent = false; this.otp = ''; },
    async submit() {
      this.error = ''; this.loading = true;
      try {
        if (this.mode === 'login') {
          const resp = await login({ email: this.form.email, password: this.form.password });
          if (resp?.requires_2fa) {
            this.otpTicket = resp.ticket;
            this.mode = '2fa';
            return;
          }
        } else {
          await register({
            name: this.form.name, email: this.form.email,
            password: this.form.password,
            password_confirmation: this.form.password_confirmation
          });
        }
        const redirect = this.$route.query.redirect || '/dashboard';
        this.$router.push(redirect);
      } catch (e) {
        const resp = e?.response?.data;
        if (resp?.errors)      this.error = Object.values(resp.errors).flat()[0] || 'Error de validación.';
        else if (resp?.message) this.error = resp.message;
        else this.error = this.mode === 'login'
          ? 'Credenciales inválidas. Verificá email y contraseña.'
          : 'No se pudo crear la cuenta.';
      } finally { this.loading = false; }
    },
    async submit2fa() {
      this.error = ''; this.loading = true;
      try {
        await loginTwoFactor({ ticket: this.otpTicket, code: this.otp });
        const redirect = this.$route.query.redirect || '/dashboard';
        this.$router.push(redirect);
      } catch (e) {
        this.error = e?.response?.data?.message || 'Código inválido.';
        if (e?.response?.status === 401 && /ticket/i.test(e?.response?.data?.message || '')) {
          setTimeout(() => this.switchMode('login'), 1500);
        }
      } finally { this.loading = false; }
    },
    async submitForgot() {
      this.error = ''; this.loading = true;
      try {
        await api.post('/password/forgot', { email: this.form.email });
        this.forgotSent = true;
      } catch (e) {
        this.error = e?.response?.data?.message || 'No se pudo enviar el email.';
      } finally { this.loading = false; }
    },
    loginGoogle() { window.location.href = `${API_BASE}/auth/google/redirect`; }
  }
};
</script>

<style scoped>
.lv-page{ position:fixed; inset:0; display:flex; overflow:hidden; background:#03203E; }
.lv-left{
  flex:0 0 57%; position:relative; display:flex; flex-direction:column;
  padding:48px 52px 38px; overflow:hidden; color:#fff;
}
.lv-bg-img{
  position:absolute; inset:0; width:100%; height:100%;
  object-fit:cover; object-position:center 45%;
  z-index:0; pointer-events:none; user-select:none;
}
.lv-overlay{
  position:absolute; inset:0; z-index:1;
  background:linear-gradient(
    to bottom,
    rgba(3,27,52,0.72) 0%,
    rgba(3,27,52,0.52) 26%,
    rgba(3,43,82,0.12) 44%,
    rgba(3,43,82,0.18) 62%,
    rgba(3,27,52,0.70) 82%,
    rgba(3,27,52,0.85) 100%
  );
  pointer-events:none;
}
.lv-brand{ position:relative; z-index:2; display:flex; align-items:center; gap:20px; flex-shrink:0; }
.lv-logo{
  width:76px; height:76px; border-radius:18px;
  background:linear-gradient(135deg,
    rgba(124,168,216,0.22) 0%,
    rgba(157,202,235,0.15) 55%,
    rgba(188,223,244,0.10) 100%);
  border:1px solid rgba(157,202,235,0.30);
  display:flex; align-items:center; justify-content:center;
  flex-shrink:0; backdrop-filter:blur(8px); -webkit-backdrop-filter:blur(8px);
  box-shadow:0 4px 20px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.18);
}
.lv-logo-t{
  font-size:44px; font-weight:900; letter-spacing:-2px; line-height:1;
  background:linear-gradient(135deg, #5A82B8 0%, #7CA8D8 50%, #9DCAEB 100%);
  -webkit-background-clip:text; background-clip:text;
  -webkit-text-fill-color:transparent; color:transparent;
  filter:drop-shadow(0 1px 6px rgba(124,168,216,0.35));
}
.lv-brand-copy{ display:flex; flex-direction:column; gap:4px; }
.lv-brand-name{
  font-size:52px; font-weight:900; letter-spacing:10px; line-height:1;
  background:linear-gradient(90deg, #5A82B8 0%, #7098CE 35%, #8FBDE3 65%, #A6D2EC 100%);
  -webkit-background-clip:text; background-clip:text;
  -webkit-text-fill-color:transparent; color:transparent;
  filter:drop-shadow(0 2px 18px rgba(0,0,0,0.5));
}
.lv-brand-sub{
  font-size:12px; letter-spacing:3.4px; font-weight:600;
  color:rgba(255,255,255,0.58); text-transform:uppercase;
}
.lv-brand-sep{
  position:relative; z-index:2;
  width:48px; height:2px; border-radius:2px;
  background:var(--mhlm-sky); margin-top:18px; flex-shrink:0;
  box-shadow:0 0 16px rgba(41,169,224,0.5);
}
.lv-tagline{
  position:relative; z-index:2; margin-top:12px; font-size:14px;
  color:rgba(255,255,255,0.5); letter-spacing:0.02em; flex-shrink:0;
}
.lv-spacer{ flex:1; min-height:60px; }
.lv-pitch{ position:relative; z-index:2; flex-shrink:0; }
.lv-pitch-title{
  font-size:23px; font-weight:700; color:#fff;
  line-height:1.3; letter-spacing:-0.02em;
  margin-bottom:16px; text-shadow:0 2px 16px rgba(0,0,0,0.6);
}
.lv-feats{ list-style:none; display:flex; flex-direction:column; gap:9px; padding:0; margin:0; }
.lv-feat{ display:flex; align-items:center; gap:11px; font-size:13px; color:rgba(255,255,255,0.68); line-height:1.4; }
.lv-feat strong{ color:rgba(255,255,255,0.94); }
.lv-feat-ico{
  flex-shrink:0; width:26px; height:26px; border-radius:7px;
  background:rgba(255,255,255,0.09); border:1px solid rgba(255,255,255,0.13);
  display:flex; align-items:center; justify-content:center;
  color:rgba(255,255,255,0.72);
}

.lv-right{ flex:1; background:#fff; display:flex; flex-direction:column; overflow-y:auto; }
.lv-form-wrap{ flex:1; display:flex; flex-direction:column; justify-content:center; padding:40px 48px; }
.lv-head-row{ display:flex; justify-content:space-between; align-items:baseline; margin-bottom:22px; }
.lv-title{ font-size:20px; font-weight:600; color:var(--tx-hi); margin:0; }
.lv-link{ font-size:13px; color:var(--accent); text-decoration:none; cursor:pointer; }
.lv-link:hover{ text-decoration:underline; }
.lv-hint{ font-size:13px; color:var(--tx-md); margin:-8px 0 18px; }
.lv-form{ display:flex; flex-direction:column; }
.lv-field{
  display:flex; align-items:center;
  border:1px solid var(--border-s);
  border-radius:8px; background:var(--surface);
  margin-bottom:10px; transition:border-color .15s, box-shadow .15s;
  min-height:40px;
}
.lv-field:focus-within{ border-color:var(--accent); box-shadow:0 0 0 3px var(--acc-lt); }
.lv-ico{ margin:0 6px 0 12px; color:var(--tx-lo); flex-shrink:0; }
.lv-input{
  flex:1; border:none; outline:none; background:transparent;
  padding:10px 10px 10px 0; font-size:13.5px; color:var(--tx-hi);
  font-family:inherit; min-width:0;
}
.lv-input::placeholder{ color:var(--tx-lo); }
.lv-eye{ background:none; border:none; cursor:pointer; padding:0 10px; color:var(--tx-lo); display:flex; align-items:center; }
.lv-eye:hover{ color:var(--tx-md); }
.lv-opts{ display:flex; justify-content:space-between; align-items:center; font-size:12.5px; color:var(--tx-md); margin:4px 0 14px; }
.lv-check{ display:inline-flex; align-items:center; gap:6px; cursor:pointer; user-select:none; }
.lv-check input{ accent-color:var(--accent); cursor:pointer; }
.lv-error{ margin:4px 0 10px; padding:9px 12px; border-radius:8px; background:var(--mhlm-pastel-rose); color:#8a2a2a; font-size:12.5px; }
.lv-info{ margin:4px 0 10px; padding:9px 12px; border-radius:8px; background:var(--mhlm-pastel-mint); color:#1f6a43; font-size:12.5px; }
.lv-submit{
  display:flex; align-items:center; justify-content:center;
  padding:11px 16px; border:none; border-radius:8px;
  background:var(--mhlm-grad); background-size:140% 100%; background-position:0% 0%;
  color:#fff; font-size:14px; font-weight:600; cursor:pointer;
  box-shadow:0 3px 10px rgba(21,96,189,.28);
  transition:background-position .35s, box-shadow .2s, transform .08s;
  margin-top:6px;
}
.lv-submit:hover{ background-position:100% 0%; box-shadow:0 4px 14px rgba(21,96,189,.38); }
.lv-submit:active{ transform:scale(.98); }
.lv-submit:disabled{ opacity:.6; cursor:not-allowed; }
.lv-divider{ display:flex; align-items:center; gap:10px; margin:20px 0 14px; color:var(--tx-lo); font-size:11.5px; text-align:center; }
.lv-divider::before,.lv-divider::after{ content:''; flex:1; height:1px; background:var(--border); }
.lv-social{ display:grid; grid-template-columns:1fr; gap:8px; }
.lv-soc{
  display:flex; align-items:center; justify-content:center; gap:10px;
  padding:10px 12px; border:1px solid var(--border-s);
  border-radius:8px; background:#fff;
  color:var(--tx-hi); font-size:13px; font-weight:600; cursor:pointer;
  font-family:inherit; transition:background .15s, border-color .15s;
}
.lv-soc:hover{ background:var(--acc-xlt); border-color:var(--accent); }

.lv-right-bg,.lv-right-overlay,.lv-mob-brand,.lv-mob-pitch{ display:none; }

@media (max-width: 1024px){
  .lv-left{ flex:0 0 48%; padding:36px 32px 28px; }
  .lv-brand-name{ font-size:40px; letter-spacing:7px; }
  .lv-logo{ width:60px; height:60px; border-radius:14px; }
  .lv-logo-t{ font-size:32px; }
  .lv-pitch-title{ font-size:19px; }
  .lv-form-wrap{ padding:28px 28px; }
  .lv-title{ font-size:18px; }
}
@media (max-width: 900px){
  .lv-left{ flex:0 0 44%; padding:28px 24px 24px; }
  .lv-brand-name{ font-size:34px; letter-spacing:6px; }
  .lv-logo{ width:52px; height:52px; }
  .lv-logo-t{ font-size:28px; }
  .lv-pitch-title{ font-size:17px; }
  .lv-form-wrap{ padding:24px 24px; }
}
@media (max-width: 640px){
  .lv-left{ display:none; }
  .lv-right{ flex:1; position:relative; overflow-y:auto; background:transparent; }
  .lv-right-bg{
    display:block; position:fixed; inset:0; width:100%; height:100%;
    object-fit:cover; object-position:38% center; z-index:0; pointer-events:none;
  }
  .lv-right-overlay{
    display:block; position:fixed; inset:0; z-index:1;
    background:linear-gradient(to bottom, rgba(3,27,52,0.58) 0%, rgba(3,43,82,0.52) 55%, rgba(3,27,52,0.72) 100%);
    pointer-events:none;
  }
  .lv-mob-brand,.lv-form-wrap,.lv-mob-pitch{ position:relative; z-index:2; }
  .lv-mob-brand{ display:flex; align-items:center; gap:14px; padding:44px 20px 0; flex-shrink:0; }
  .lv-mob-logo{
    width:48px; height:48px; border-radius:10px;
    background:linear-gradient(135deg, rgba(124,168,216,0.20) 0%, rgba(157,202,235,0.14) 60%, rgba(188,223,244,0.10) 100%);
    border:1px solid rgba(157,202,235,0.26);
    display:flex; align-items:center; justify-content:center;
    flex-shrink:0; backdrop-filter:blur(6px); -webkit-backdrop-filter:blur(6px);
    box-shadow:0 2px 10px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.18);
  }
  .lv-mob-logo-t{
    font-size:26px; font-weight:900; line-height:1; letter-spacing:-1px;
    background:linear-gradient(135deg, #5A82B8 0%, #7CA8D8 50%, #9DCAEB 100%);
    -webkit-background-clip:text; background-clip:text;
    -webkit-text-fill-color:transparent; color:transparent;
  }
  .lv-mob-name{
    font-size:30px; font-weight:800; letter-spacing:.14em; line-height:1.1;
    background:linear-gradient(90deg, #5A82B8 0%, #7098CE 40%, #8FBDE3 70%, #A6D2EC 100%);
    -webkit-background-clip:text; background-clip:text;
    -webkit-text-fill-color:transparent; color:transparent;
    filter:drop-shadow(0 1px 8px rgba(0,0,0,0.4));
  }
  .lv-mob-sub{ font-size:8.5px; letter-spacing:.22em; font-weight:400; color:rgba(255,255,255,0.55); text-transform:uppercase; margin-top:4px; }
  .lv-form-wrap{
    flex:0; margin:22px 16px 0; padding:22px 20px 18px;
    background:rgba(255,255,255,0.97); border-radius:16px;
    box-shadow:0 12px 48px rgba(0,0,0,0.4);
    backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px);
    justify-content:flex-start;
  }
  .lv-head-row{ margin-bottom:16px; }
  .lv-title{ font-size:18px; }
  .lv-submit{ padding:10px 14px; font-size:13.5px; }
  .lv-divider{ margin:14px 0 10px; }
  .lv-mob-pitch{ display:block; padding:22px 24px 24px; margin-top:auto; flex-shrink:0; }
  .lv-mob-pitch-title{
    font-size:17px; font-weight:700; color:#fff; line-height:1.3; letter-spacing:-0.01em;
    margin:0 0 10px; text-shadow:0 2px 12px rgba(0,0,0,0.55);
  }
  .lv-mob-feats{ list-style:none; padding:0; margin:0 0 12px; display:flex; flex-direction:column; gap:5px; font-size:12.5px; color:rgba(255,255,255,0.72); }
  .lv-mob-feats li{ display:flex; align-items:center; gap:8px; }
  .lv-mob-feats li::before{ content:''; width:5px; height:5px; border-radius:50%; background:var(--mhlm-sky); box-shadow:0 0 8px rgba(41,169,224,0.6); flex-shrink:0; }
  .lv-mob-feats strong{ color:#fff; font-weight:600; }
  .lv-mob-foot{ font-size:10.5px; color:rgba(255,255,255,0.4); letter-spacing:.04em; padding-top:14px; border-top:1px solid rgba(255,255,255,0.08); }
}
@media (max-width:380px){
  .lv-mob-brand{ padding:32px 16px 0; }
  .lv-mob-name{ font-size:26px; letter-spacing:.12em; }
  .lv-form-wrap{ margin:18px 12px 0; padding:20px 16px 16px; }
  .lv-mob-pitch{ padding:18px 18px 20px; }
}
</style>
